import React from 'react'
import First from './HomepageSections/First'
import Third from './HomepageSections/Third'
import Second from './HomepageSections/Second'
import "./pages.scss"
import Fourth from './HomepageSections/Fourth'
export default function Homepage() {
  return (
    <div className='Homepage'>
        <First/>
        <Second/>
      {/* <Third/> */}
        {/* <Fourth/> */} 
      
    </div>
  )
}
